import { computed } from 'vue'

const DEV_HOSTS = [
  'localhost',
  'local.appewa.com',
  'dev.appewa.com',
  'stg.appewa.com',
  'pre.appewa.com'
]

export const useAppEnvironment = () => {
  const isPre = computed(() => __ENVIRONMENT_NAME__.startsWith('pre'))
  const isStaging = computed(() => __ENVIRONMENT_NAME__.startsWith('staging'))
  const isProduction = computed(() =>
    __ENVIRONMENT_NAME__.startsWith('production')
  )
  const isDevelopment = computed(() =>
    __ENVIRONMENT_NAME__.startsWith('development')
  )

  const showDevMenu = computed(() => {
    return DEV_HOSTS.some((host) => window.location.hostname.includes(host))
  })

  return {
    isPre,
    isStaging,
    isProduction,
    isDevelopment,
    showDevMenu
  }
}
